module.exports = __webpack_public_path__ + "img/efsa.634b51bd.png";